<div class="modal active {{ cssClass }}" id="modal-id">
  <a class="modal-overlay"></a>
  <div class="modal-container">
    <div class="modal-header">
      <a class="btn btn-clear float-right" (click)="closeModal()"></a>
      <div class="modal-title h5">{{ title }}</div>
    </div>
    <div class="modal-body">
      <div #hostedComponent></div>
    </div>
  </div>
</div>